import { render, staticRenderFns } from "./ParticipantWinnerItem.vue?vue&type=template&id=3439e96a&"
import script from "./ParticipantWinnerItem.vue?vue&type=script&lang=js&"
export * from "./ParticipantWinnerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports